import LdGatedSwitch from 'lion-vue-src/Shared/components/LdFeatureGate/LdGatedSwitch';
export default LdGatedSwitch;